<template>
  <div>
    <div
      class="modal fade form-wrapper"
      id="edit-gift-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="formModalLabel"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
      v-if="showModal"
      @close="closeModal"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content form-content">
          <div class="modal-body">
            <div
              class="img-upload d-flex flex-wrap align-items-center justify-content-center"
              id="image"
            >
              <img
                class="close"
                src="../../../public/assets/images/close.svg"
                data-dismiss="modal"
                aria-label="Close"
                @click="closeModal"
              />
              <img
                :src="getGiftDetails.productImage.length!=0?getGiftDetails.productImage[0].image:'/img/event1.287e79dd.png'"
                style="height : 100%;"
                v-if="imagePreview == null"
              />
              <!-- <h1 v-if="imagePreview === null">Purano image</h1> -->
              <img v-if="cropped" v-bind:src="cropped" :class="{fullHeight:cropped != null}" />
              <vue-croppie
                v-show="imagePreview !== null && imagePreview !== ''"
                ref="croppieRef"
                :enableOrientation="true"
                :enforceBoundary="true"
                :enableResize="false"
                @result="result"
                :enableExif="true"
                :mouseWheelZoom="false"
                :enableKeyMovement="true"
                :showZoomer="true"
                :viewport="{ width: 322, height: 215, type: 'square' }"
                :boundry="{ width: 600, height: 430}"
              ></vue-croppie>
              <input type="file" ref="file" style="display:none" v-on:change="handleFileUpload()" />
              <button
                v-if="imagePreview && !cropped"
                class="btn btn-primary crop-button"
                @click="cancelBanner()"
              >
                <i class="fa fa-times"></i>
                Cancel
              </button>
              <button
                v-if="!imagePreview || cropped"
                class="btn btn-primary crop-button"
                @click="$refs.file.click()"
              >
                <i class="fa fa-upload"></i>
                Change banner
              </button>
              <button
                v-if="imagePreview && !cropped"
                class="btn btn-primary crop-button crop"
                style="right : 180px"
                @click="crop()"
              >Crop</button>
            </div>

            <div class="create-form">
              <form @submit.prevent="editGiftMethod">
                <div class="form-group">
                  <input
                    type="text"
                    name="productName"
                    v-model="productName"
                    class="form-control"
                    data-vv-as="gift name"
                    v-validate="{required:true, min:1, max:500 /*regex:/^[A-Z][a-z]{0,49}$/*/}"
                    ref="productName"
                    v-bind:class="{ 'is-invalid': errors.has('productName')}"
                  />
                  <div class="invalid-feedback">{{ errors.first('productName') }}</div>
                </div>
               
                <div class="form-group">
                  <label for="cname">Desirability</label>
                  <div class="select-details">
                    <select class="form-control" v-model="want" name="want">
                      <option value="">No Preference</option>
                      <option>Useful</option>
                      <option>Wants</option>
                      <option>Really Wants</option>
                      <option>Must Have</option>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <label for="cname">More details</label>
                  <textarea
                    type="text"
                    class="form-control"
                    name="productDetails"
                    data-vv-as="more details"
                    v-model="productDetails"
                    v-validate="'min:3|max:250'"
                    ref="productDetails"
                    v-bind:class="{ 'is-invalid': errors.has('productDetails')}"
                  ></textarea>
                  <span class="text-right">{{ detailCharacterCount }} / 250</span>
                  <div class="invalid-feedback">{{ errors.first('productDetails') }}</div>
                </div>
                <div class="form-group">
                  <label for="detail">Price</label>
                  <input
                    type="text"
                    name="productPrice"
                    v-model="productPrice"
                    class="form-control"
                    data-vv-as="price"
                    v-validate="'priceFormat|min:0'"
                    ref="productPrice"
                    v-bind:class="{ 'is-invalid': errors.has('productPrice')}"
                  />
                  <div class="invalid-feedback">{{ errors.first('productPrice') }}</div>
                </div>

                <div class="form-group">
                  <label for="toBuy">Where to buy</label>
                  <input
                    type="text"
                    class="form-control"
                    id="buyPlace"
                    name="buyPlace"
                    placeholder="Amazon"
                    data-vv-as="where to buy"
                    v-model="buyPlace"
                    v-validate="'min:3'"
                    ref="buyPlace"
                    v-bind:class="{ 'is-invalid': errors.has('buyPlace')}"
                  />
                  <div class="invalid-feedback">{{ errors.first('buyPlace') }}</div>
                </div>

                <div class="form-group">
                  <label for="date">Quantity</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="productQuantity"
                    :min="minimumProductQuantity"
                    v-validate="minimumQuantityValidation"
                    name="productQuantity"
                    data-vv-as="quantity"
                  />

                  <div class="invalid-feedback">{{ errors.first('productQuantity') }}</div>
                </div>

                <div class="form-group">
                  <label for="date">Size</label>
                  <input
                    type="text"
                    class="form-control"
                    name="productSize"
                    data-vv-as="size"
                    v-model="productSize"
                    v-validate="'min:1|productSizeFormat'"
                    ref="productSize"
                    v-bind:class="{ 'is-invalid': errors.has('productSize')}"
                  />
                  <div class="invalid-feedback">{{ errors.first('productSize') }}</div>
                </div>
               <!-- <div class="form-group">
                  <label for="date">Colour</label>
                  <input
                    type="text"
                    class="form-control"
                    name="productColor"
                    data-vv-as="colour"
                    v-model="productColor"
                    v-validate="'min:3|max:50'"
                    ref="productColor"
                    v-bind:class="{ 'is-invalid': errors.has('productColor')}"
                  />
                  <div class="invalid-feedback">{{ errors.first('productColor') }}</div>
                </div>
                  -->
                <div
                  class="alert alert-primary alert-dismissible"
                  role="alert"
                  v-show="showSuccessAlertMessage"
                >
                  {{apiSuccessMessage}}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                    @click="showSuccessAlertMessage = !showSuccessAlertMessage"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div
                  class="alert alert-danger alert-dismissible"
                  role="alert"
                  v-show="showAlertMessage"
                >
                  {{apiErrorMessage}}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                    @click="showAlertMessage = !showAlertMessage"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div
                  v-if="(showSpinner === true)"
                  class="spinner-border"
                  style="width: 3rem; height: 3rem;color:#FD3E75;top:50%;left:50%"
                  role="status"
                ></div>
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="disabled == true"
                >{{buttonText}}</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueCroppie from "vue-croppie";
import "croppie/croppie.css"; // import the croppie css manually
import {
  EDIT_GIFT,
  UPLOAD_GIFT_IMAGE,
  SET_GIFT_DETAILS
} from "../../store/gift/action.type";

export default {
  props: {
    show: Boolean
  },

  data() {
    return {
      showAlertMessage: false,
      showSuccessAlertMessage: false,
      apiSuccessMessage: "",
      apiErrorMessage: "",
      productName: "",
      productPrice: "",
      productDetails: "",
      buyPlace: "",
      want: "",
      productSize: "",
      productColor: "",
      productQuantity: "",
      imagePreview: null,
      cropped: null,
      editedGift: {},
      disabled: false,
      buttonText: "Update",
      showSpinner: null,
      uploadedImage: "",
      cancelImage: false,
      minimumProductQuantity: 0
    };
  },

  computed: {
    ...mapGetters(["getGiftDetails"]),
    showModal() {
      console.log('gift details',this.getGiftDetails)
      this.productName = this.getGiftDetails.productName;
      this.productPrice = this.getGiftDetails.productPrice;
      this.productDetails = this.getGiftDetails.detail;
      this.buyPlace = this.getGiftDetails.whereToBuy;

      // process want
      if(this.getGiftDetails.want.indexOf('wants') !== -1){
        if(this.getGiftDetails.want.indexOf('really wants') !== -1){
         this.want = 'Really Wants';
        }
        else{
           this.want = 'Wants';
        }
       }
        else if(this.getGiftDetails.want.indexOf('useful') !== -1){
        
           this.want = 'Useful';
        
       }
       else if(this.getGiftDetails.want.indexOf('must have') !== -1){
        
           this.want = 'Must Have';
        
       }
       else{
        this.want = '';
       }

      this.productSize = this.getGiftDetails.productSize;
      this.productColor = this.getGiftDetails.productColor;
      this.productQuantity = this.getGiftDetails.productQuantity;
      this.minimumProductQuantity = this.getGiftDetails.productQuantity;
      return this.show === true
        ? $("#edit-gift-modal").modal("show")
        : $("#edit-gift-modal").modal("hide");
    },

    detailCharacterCount() {
      let char = this.productDetails;
      if (char) {
        return char.length;
      } else {
        return 0;
      }
    },
    minimumQuantityValidation() {
      return {
        min_value : this.minimumProductQuantity
      }
    }
  },

  created() {
    this.$validator.extend("productSizeFormat", {
      getMessage: field => `${field} must not contain special character`,
      validate: value => value.match(/^[a-zA-Z0-9_ ]*$/) !== null
    });
    this.$validator.extend("priceFormat", {
      getMessage: () => "Price must be alphanumeric",
      validate: value => value.match(/^[a-zA-Z0-9 -.]*$/) !== null
    });
  },

  methods: {
    closeModal() {
      this.$emit("close");
      this.cropped = null;
      this.showPreview = false;
      this.imagePreview = null;
      (this.productName = ""),
        (this.productPrice = ""),
        (this.productDetails = ""),
        (this.buyPlace = ""),
        (this.want = ""),
        (this.productSize = ""),
        (this.productColor = ""),
        (this.productQuantity = ""),
        (this.showSpinner = false);
      this.refresh();
    },

    refresh() {
      this.$refs.croppieRef.destroy();
    },
    initCroppie() {
      this.$refs.croppieRef.initCroppie();
    },
    initialiseCropper() {
      if (this.$refs.croppieRef) {
        this.$refs.croppieRef.bind({
          url: this.imagePreview,
          zoom: 0.2
        });
      }
    },
    result(output) {
      this.cropped = output;
    },

    handleFileUpload() {
      this.imagePreview = null;
      this.cancelImage = false;
      this.cropped = null;

      this.file = this.$refs.file.files[0];

      let reader = new FileReader();

      reader.addEventListener(
        "load",
        function() {
          this.showPreview = true;
          this.imagePreview = reader.result;
          this.$refs.file.value = "";
          this.initCroppie();
          this.$refs.croppieRef.bind({
            url: this.imagePreview,
            zoom: 0.2
          });
        }.bind(this),
        false
      );

      if (this.file) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
          this.file = "";
        }
        this.refresh();
      }
    },

    crop() {
      let options = {
        format: "jpeg",
        circle: false,
        size: { width: 1028 }
      };
      this.$refs.croppieRef.result(options, output => {
        this.cropped = output;
      });

      this.refresh();
    },

    editGiftMethod(e) {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.showSpinner = true;
          this.disabled = true;
          this.buttonText = "Updating";
          if (this.cropped) {
            this.editGiftImage();
          } else {
            this.saveEditedGift();
          }
        }
      });
    },

    /* Upload gift image */
    editGiftImage() {
      const uploadBody = {
        image: this.cropped
      };
      if (this.cropped) {
        this.$store
          .dispatch(UPLOAD_GIFT_IMAGE, uploadBody)
          .then(response => {
            if (response.status == 200) {
              this.uploadedImage = response.data.data.file;
            } else {
              this.showSpinner = false;
              this.disabled = false;
              this.buttonText = "Update";
              this.apiErrorMessage = response.data.message;
              this.showAlertMessage = true;
            }
            this.saveEditedGift();
          })
          .catch(error => {
            console.log(error);
          });
      }
    },

    saveEditedGift() {
      const body = {
        productName: this.productName,
        productQuantity: this.productQuantity,
        want: this.want === "" ? "No Preference" : this.want
      };
      if (this.uploadedImage) {
        body.productImage = [{ image: this.uploadedImage }];
      }
      if (this.productDetails) body.detail = this.productDetails;

      if (this.buyPlace) body.whereToBuy = this.buyPlace;

      if (this.productColor) body.productColor = this.productColor;

      if (this.productSize) body.productSize = this.productSize;

      if (this.productPrice) body.productPrice = this.productPrice;

      const giftDetails = {
        giftId: this.getGiftDetails._id,
        giftBody: body
      };
      this.$store
        .dispatch(EDIT_GIFT, giftDetails)
        .then(response => {
          if (response.status == 200) {
            this.editedGift = response.data.data;
            this.editedGift.productImage = [{ image: this.uploadedImage }];
            this.$store.dispatch(SET_GIFT_DETAILS, this.editedGift); //set the response of edit gift api
            this.apiSuccessMessage = response.data.message;
            this.showSuccessAlertMessage = true;
            this.disabled = false;
            this.buttonText = "Update"
            this.closeModal(); //close modal which changes the value from store(in ListGift)
            // this.$router.go({ path: "Wishlist Details" });
          } else {
            this.apiErrorMessage = response.data.message;
            this.showAlertMessage = true;
          }
        })
        .catch(error => {
          this.showSpinner = false;
          this.disabled = false;
          this.buttonText = "Update";
          this.apiErrorMessage = error.response.data.message;
          this.showAlertMessage = true;
        });
    },
    cancelBanner() {
      this.refresh();
      this.imagePreview = null;
      this.cropped = null;
      this.cancelImage = true;
      this.initCroppie();
    }
  },
  watch: {
    showAlertMessage(newData) {
      if (newData) {
        var self = this;
        setTimeout(function() {
          self.showAlertMessage = false;
        }, 2000);
      }
    },
    showSuccessAlertMessage(newData) {
      if (newData) {
        var self = this;
        setTimeout(function() {
          self.showSuccessAlertMessage = false;
        }, 2000);
      }
    }
  }
};
</script>

<style>
</style>